import { jsx as _jsx } from "react/jsx-runtime";
import { PropertyLine } from "./propertyLine";
import { Switch } from "../../primitives/switch";
/**
 * Wraps a switch in a property line
 * @param props - The properties for the switch and property line
 * @returns A React element representing the property line with a switch
 */
export const SwitchPropertyLine = (props) => {
    SwitchPropertyLine.displayName = "SwitchPropertyLine";
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { label, ...switchProps } = props;
    // Ensure the label gets passed to the PropertyLine component and not to the underlying switch
    return (_jsx(PropertyLine, { ...props, children: _jsx(Switch, { ...switchProps }) }));
};
//# sourceMappingURL=switchPropertyLine.js.map